import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown 
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-6' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What are the fee structures for Maxiom's investment services?",
      answer: "Our fee structures vary by service: For PMS (Portfolio Management Services), we charge a management fee and a performance fee based on your portfolio's performance. For Investment Advisory, we offer a transparent flat fee with no hidden costs, exit loads, or brokerage sharing. Mutual Fund advisory includes research and selection for a fixed advisory fee. All our pricing options are designed to align our interests with our clients' success."
    },
    {
      question: "Is there a minimum investment amount required?",
      answer: "Yes, for our PMS (Portfolio Management Services), the minimum investment is ₹50 lakhs as required by SEBI regulations. For our Investment Advisory services focusing on direct stocks, we typically recommend a minimum corpus of ₹10 lakhs to ensure proper diversification. Our Mutual Fund advisory services are available with lower minimums, making them accessible to a wider range of investors."
    },
    {
      question: "Are there any hidden charges or exit loads in your services?",
      answer: "No, we operate with complete transparency. We do not charge any hidden fees, entry loads, or exit loads across our services. For our PMS offerings, all applicable fees are clearly mentioned in our agreement and disclosure document. For advisory services, we charge only the agreed-upon advisory fee, with no brokerage sharing or commissions. This transparency is a core part of our commitment to putting clients' interests first."
    },
    {
      question: "How does your performance-based fee structure work for PMS?",
      answer: "Our PMS performance fee is calculated on a high-water mark principle, which means we only charge performance fees on new profits above your previous highest portfolio value. This structure ensures we only get rewarded when we create actual value for you. Performance fees are typically calculated annually, with clear benchmarks and hurdle rates specified in your agreement. This aligns our interests with your portfolio growth."
    },
    {
      question: "Do you offer any discounts for larger investment amounts?",
      answer: "Yes, we offer tiered fee structures with automatic discounts as your investment corpus grows. These discounts typically apply at slabs of ₹2 crore, ₹5 crore, and ₹10 crore across our services. This approach rewards client loyalty and larger investments with more favorable fee percentages. Please contact our team for specific details on the discount structure applicable to your chosen service."
    },
    {
      question: "What investment plans do you offer for systematic investing?",
      answer: "We support flexible investment deployment options across all our services. These include lumpsum investments (one-time or staggered over weeks/months), Systematic Investment Plans (SIPs) with customizable frequencies (monthly, weekly, etc.), and Systematic Transfer Plans (STPs) for gradually moving funds from liquid investments to equity positions. Our advisory and PMS services accommodate all these approaches based on your preference and market conditions."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
            Pricing FAQs
            </h2>
            <p className="text-gray-600 mb-8">
            Common questions about our pricing structures for stocks, mutual funds, and portfolio management services. Transparent information to help you make informed investment decisions.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;